module.exports = __webpack_public_path__ + "img/image8.27607010.png";